<script>
  import { afterUpdate } from "svelte";

  /**@type {boolean}*/
  export let isOpen = false;
  /**@type {string}*/
  export let style = "";
  /**@type {HTMLDialogElement}*/
  let dialog;
  $: {
    isOpen;
    afterUpdate(() => {
      isOpen ? dialog.showModal() : dialog.close();
    });
  }

  /**@param {*}e*/
  const closeByBackdrop = (e) => {
    let rect = e.target.getBoundingClientRect();
    if (
      rect.left > e.clientX ||
      rect.right < e.clientX ||
      rect.top > e.clientY ||
      rect.bottom < e.clientY
    ) {
      dialog.close();
      isOpen = false;
    }
  };
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<dialog
  {style}
  bind:this={dialog}
  id="global-modal"
  on:click={(e) => closeByBackdrop(e)}
>
  <button
    class="close-modal"
    on:click={() => {
      dialog.close();
      isOpen = false;
    }}>x</button
  >
  <slot />
</dialog>

<style>
  dialog {
    padding: 3rem 3rem 6rem 3rem;
    border-radius: 4rem;
    border: 0.3rem solid var(--orange);
    width: 95svw;
    max-width: 72rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .close-modal {
    position: absolute;
    top: 2rem;
    right: 2rem;
    font-size: 3rem;
    font-family: sirenia;
    color: var(--orange);
    width: 3rem;
    height: 3rem;
    aspect-ratio: 1/1;
    border: none;
    background: none;
    cursor: pointer;
  }
</style>
